@if (arbetsorder !== undefined) {
  <div
    #draggableArbetsorder
    (mouseenter)="hoverRow(arbetsorder.beteckning, true)"
    (mouseleave)="hoverRow(arbetsorder.beteckning, false)"
    style="width:100%"
    class="arbetsorder-header"
    [ngClass]="{
    'ao-row-hover': !isDetailedView && arbetsorder.hover, 'ao-row-selected': arbetsorder.selected,
    'arbetsorder-header-detail': isDetailedView,
    'arbetsorder-header-bottom-border': !isDetailedView,
    'planeringsstatus_tillgangligt': arbetsorder.planeringsstatus === 'Tillgängligt',
    'planeringsstatus_fardigplanerat': arbetsorder.planeringsstatus === 'Färdigplanerat',
    'planeringsstatus_under-planering': arbetsorder.planeringsstatus === 'Under planering'}">
    <rask-arbetsorder-info-icon [arbetsorder]="arbetsorder" [useImage]="true"></rask-arbetsorder-info-icon>
    <div class="arbetsorder-info">
      <div class="header-table">
        <div [ngClass]="{'table-cell table-cell-title': !isDetailedView}">
          @if (isDetailedView) {
            <div>
              <span class="anchor-title detail-title" [textContent]="arbetsorder.namn"></span>
            </div>
          } @else {
            <a class="anchor-title" [routerLink]="['/planera', arbetsorder.id]" ignore-read-only [textContent]="arbetsorder.namn"></a>
          }
        </div>
        @if (!isDetailedView) {
          <div>
            <ng-container *ngTemplateOutlet="aoHeaderDetails"></ng-container>
          </div>
        }
      </div>
      @if (isDetailedView) {
        <div class="second-header-table">
          <ng-container *ngTemplateOutlet="aoHeaderDetails"></ng-container>
        </div>
      }
      @if (arbetsorder !== undefined) {
        <rask-arbetsorder-header-list-row [arbetsorder]="arbetsorder"></rask-arbetsorder-header-list-row>
      }
    </div>
  </div>
}

<ng-template #aoHeaderDetails>
  <div class="table-cell" [ngClass]="{'detail-table-cell-beteckning': isDetailedView, 'table-cell-beteckning': !isDetailedView }" [textContent]="arbetsorder.beteckning"></div>
  <div class="table-cell" [ngClass]="{'detail-table-cell-volym': isDetailedView, 'table-cell-volym': !isDetailedView}">
    <span [textContent]="arbetsorder.volymArbetsorder"></span>&nbsp;
    <span translate="PLANERA_ARBETSORDER_HEADER_M3FUB"></span>
    @if (!hasKvalitetssakradVolym) {
      <rask-icon class="percentage-icon" icon="far fa-percent" text="Grotvolymen baseras på en procentuell beräkning"></rask-icon>
    }
  </div>
  <div class="table-cell" [ngClass]="{'detail-table-cell-medelstam': isDetailedView, 'table-cell-medelstam': !isDetailedView}">
    @if (!arbetsorder.isGrotskotning) {
      <span>{{ arbetsorder.medelstam | number: '1.2-2' }}</span>
    }
  </div>
  @if (!isDetailedView) {
    <div class="table-cell table-cell-vald">
      <div class="custom-control custom-checkbox">
        <input id="input_{{arbetsorder.id}}" type="checkbox" [checked]="arbetsorder.selected === true" (click)="selectRow(arbetsorder.beteckning)"
          class="custom-control-input ng-pristine ng-untouched ng-valid ng-empty" />
          <label class="custom-control-label small" for="input_{{arbetsorder.id}}"></label>
        </div>
      </div>
    }
  </ng-template>
